"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SpecimenDefinition_TypeTested = exports.SpecimenDefinition_TypeTestedPreferenceKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_SpecimenDefinition_Container_1 = require("./RTTI_SpecimenDefinition_Container");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_SpecimenDefinition_Handling_1 = require("./RTTI_SpecimenDefinition_Handling");
var SpecimenDefinition_TypeTestedPreferenceKind;
(function (SpecimenDefinition_TypeTestedPreferenceKind) {
    SpecimenDefinition_TypeTestedPreferenceKind["_preferred"] = "preferred";
    SpecimenDefinition_TypeTestedPreferenceKind["_alternate"] = "alternate";
})(SpecimenDefinition_TypeTestedPreferenceKind = exports.SpecimenDefinition_TypeTestedPreferenceKind || (exports.SpecimenDefinition_TypeTestedPreferenceKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_SpecimenDefinition_TypeTested = t.recursion('ISpecimenDefinition_TypeTested', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        isDerived: t.boolean,
        _isDerived: RTTI_Element_1.RTTI_Element,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        preference: (0, EnumType_1.createEnumType)(SpecimenDefinition_TypeTestedPreferenceKind, 'SpecimenDefinition_TypeTestedPreferenceKind'),
        _preference: RTTI_Element_1.RTTI_Element,
        container: RTTI_SpecimenDefinition_Container_1.RTTI_SpecimenDefinition_Container,
        requirement: t.string,
        _requirement: RTTI_Element_1.RTTI_Element,
        retentionTime: RTTI_Duration_1.RTTI_Duration,
        rejectionCriterion: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        handling: t.array(RTTI_SpecimenDefinition_Handling_1.RTTI_SpecimenDefinition_Handling)
    });
});
//# sourceMappingURL=RTTI_SpecimenDefinition_TypeTested.js.map